module.exports = __webpack_public_path__ + "img/fp2.0f9892b4.jpg";